function PolicyClause({ clause }) {
    const [[number, text]] = Object.entries(clause);

    return (
        <div className="terms-clause">
            <span className="clause-number">{number}</span>
            <div
                className="clause-text"
                dangerouslySetInnerHTML={{ __html: text }}
            />
        </div>
    );
}

export default PolicyClause;
